import AddToBagDrawer from '@sectionsJS/slider-cart/add-to-bag-drawer';
import { sliderCart } from '@sectionsJS/slider-cart';

window.addEventListener('load', async () => {
  const drawerInstance = new AddToBagDrawer();
  await sliderCart(drawerInstance);
});
